/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userBusinessUsedCoupons.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class ExternalProductDimension(
    @SerialName("index")
    val index: Int?,

    @SerialName("displayString")
    val displayString: String?,

    @SerialName("dimensionValues")
    val dimensionValues: List<ExternalProductDimensionValue>?
)
